import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import { useState } from 'react';
import gtm from '@/utils/gtm';

type ItemType = {
    title: string;
    desc: string;
    tab: string;
    img: [string, string];
};
const H: React.FC = () => {
    const { t } = useLang('d3u');
    const [active, setActive] = useState(0);
    const items: ItemType[] = [
        {
            title: t('H_item1_title'),
            desc: t('H_item1_desc'),
            img: ['https://websiteoss.ecoflow.com/upload/image/1760924788770/8_1.jpg', 'https://websiteoss.ecoflow.com/upload/image/1760924787898/8_1_M.jpg'],
            tab: t('H_item1_tab'),
        },
        {
            title: t('H_item2_title'),
            desc: t('H_item2_desc'),
            img: ['https://websiteoss.ecoflow.com/upload/image/1760924789087/8_2.jpg', 'https://websiteoss.ecoflow.com/upload/image/1760924789379/8_2_M.jpg'],
            tab: t('H_item2_tab'),
        },
        {
            title: t('H_item3_title'),
            desc: t('H_item3_desc'),
            img: ['https://websiteoss.ecoflow.com/upload/image/1760924788487/8_3.jpg', 'https://websiteoss.ecoflow.com/upload/image/1760924788148/8_3_M.jpg'],
            tab: t('H_item3_tab'),
        },
    ];

    const handleChangeTab = (tx: string, k: number) => {
        setActive(k);
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: t('H_item1_title'),
            button_name: tx,
            __btn_id1: `${css.section} .tab-${k + 1}`,
            __btn_id2: tx,
            __btn_type: 'text',
        });
    };

    return (
        <section className={`${css.section} D3U-H GtmModuleData-section`} id="D3U-H" data-section-id={'D3U-H'} data-section-id2={t('H_item1_title')}>
            <ul className="items">
                {items.map((item: ItemType, k: number) => (
                    <li key={k} className={`item DtmModuleData-btn-text${active === k ? ' active' : ''}`}>
                        <div className="info">
                            <p className="title">{item.title}</p>
                            <p className="desc">{item.desc}</p>
                        </div>
                        <div className="img">
                            <EcoImg pc={item.img[0]} pad={item.img[0]} h5={item.img[1]} />
                        </div>
                    </li>
                ))}
            </ul>
            <ul className="tabs">
                {items.map((item: ItemType, k: number) => (
                    <li
                        className={`tab${active === k ? ' active' : ''} tab-${k + 1} GtmModuleData-btn-text`}
                        key={k}
                        onClick={() => handleChangeTab(item.tab, k)}
                    >
                        <p className="name">{item.tab}</p>
                    </li>
                ))}
            </ul>
        </section>
    );
};

export default H;
